import { createRoot } from 'react-dom/client';
import {BrowserRouter as Router,} from "react-router-dom";
import {MsalProvider} from "@azure/msal-react";
import { EventType, PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";
import ErrorBoundary from "./ErrorBoundary";
import MainApp from "./App";
import reportWebVitals from "./reportWebVitals";

// Global CSS imports
import './css/bootstrap.css';
import './css/style.css';

const msalInstance = new PublicClientApplication(msalConfig);
await msalInstance.initialize();

/* Default to using the first account if no account is active on page load
if (
  !msalInstance.getActiveAccount() &&
  msalInstance.getAllAccounts().length > 0
) {
  // Account selection logic is app dependent. Adjust for different use cases.
  msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
}
*/
msalInstance.addEventCallback((event) => {
  //console.log(event.eventType);
  if (
    (event.eventType === EventType.LOGIN_SUCCESS ||
      event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
      event.eventType === EventType.SSO_SILENT_SUCCESS) &&
    event.payload.account
  ) {
    msalInstance.setActiveAccount(event.payload.account);
  }
});

const root = createRoot(document.getElementById('root'));
root.render(
 
        <Router basename="/">
         <MsalProvider instance={msalInstance}>
            <ErrorBoundary>
              <MainApp />
            </ErrorBoundary>
          </MsalProvider>
        </Router>
 
);

reportWebVitals();